import React from 'react'
import { Grid, IconButton, LinearProgress, TablePagination, Tooltip } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import clsx from 'clsx'
import { Logger } from 'wdc-cube'
import { ExportHistoryRow, HistoryResponse, HistoryScope, ProfileFilterScope } from '../../up_scopes'
import { DateFns } from './../../../../utils/date-fns'
import ProfileCard from './profile-card'

const LOG = Logger.get('UserProfile-History-Table')

const rowsPerPageOptions = [10, 25, 50, 75, 100, 500]

export type UserProfileHistoryTableProps = {
    className?: string
    style?: React.CSSProperties
    key?: string
    scope: HistoryScope
    filterScope: ProfileFilterScope
}

function UserProfileHistoryTable({ scope, filterScope, className, style }: UserProfileHistoryTableProps) {
    const historyResponse = scope.history || ({} as HistoryResponse<ExportHistoryRow>)

    const emitViewDocuments = (exportId: number) => {
        scope.onViewDocuments(exportId).catch(LOG.caught)
    }

    const columns = static_build_history_columns(emitViewDocuments)

    const emitRowsPerPageChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const pageSize = parseInt(e.target.value, 10)
        filterScope.onFind({ limit: pageSize }).catch(LOG.caught)
    }

    const emitChangePage = (__e: React.MouseEvent<HTMLButtonElement, MouseEvent> | null, newPage: number) => {
        filterScope.onFind({ page: newPage }).catch(LOG.caught)
    }

    return (
        <ProfileCard caption="Histórico de Exportações" className={clsx(className)} style={style}>
            <Grid container spacing={2}>
                <Grid size={{ sm: 12 }} sx={{ height: 594 }}>
                    <DataGrid
                        rows={historyResponse.records || []}
                        columns={columns}
                        getRowId={static_getRowId}
                        hideFooter
                        hideFooterPagination
                        disableColumnSelector
                    />
                    {scope.history_working && <LinearProgress color="secondary" />}
                </Grid>
                <Grid size={{ sm: 12 }}>
                    {historyResponse.totalRecords > historyResponse.limit && (
                        <TablePagination
                            component="div"
                            count={historyResponse.totalRecords}
                            page={historyResponse.page}
                            onPageChange={emitChangePage}
                            rowsPerPage={historyResponse.limit || 10}
                            rowsPerPageOptions={rowsPerPageOptions}
                            onRowsPerPageChange={emitRowsPerPageChange}
                        />
                    )}
                </Grid>
            </Grid>
        </ProfileCard>
    )
}
export default UserProfileHistoryTable

function static_build_history_columns(onView: (exportId: number) => void): GridColDef[] {
    return [
        {
            field: 'actions',
            headerName: 'Documentos',
            sortable: false,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            width: 110,
            renderCell(params) {
                return (
                    <Tooltip title="Ver documentos exportados">
                        <IconButton size="small" onClick={() => onView(params.row.seq!)}>
                            <VisibilityIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )
            }
        },
        {
            field: 'origem',
            headerName: 'Relatório Exportado',
            width: 250
        },
        {
            field: 'dataHora',
            headerName: 'Data Hora',
            type: 'dateTime',
            width: 150,
            valueFormatter: (value) => DateFns.formatDate(value, 'dd/MM/yyyy HH:mm')
        },
        {
            field: 'qtdRegistros',
            headerName: 'Qtd. Exportada',
            align: 'right',
            headerAlign: 'right',
            width: 150
        },
        {
            field: 'groupName',
            headerName: 'Franquia Associada',
            width: 200,
            valueFormatter: (value) => (!value ? 'Usuário' : `Grupo: ${value}`)
        },
        {
            field: 'newLimitExport',
            headerName: 'Limite Contratado',
            align: 'right',
            headerAlign: 'right',
            width: 150
        }
    ]
}

function static_getRowId(row: ExportHistoryRow) {
    return row.seq + ''
}
